<template>
    <div v-bind:class="[ 'panel', isOk ? (response.data.error_count ? 'panel-warning' : 'panel-success') : 'panel-danger' ]" v-if="finished">
        <template v-if="isOk">
            <div class="panel-heading">
                <div class="pull-right" title="Čas">
                    <span class="glyphicon glyphicon-time"></span>
                    {{ response.data.time.toFixed(2) }} s
                </div>

                <b>Import dokončený!</b>
            </div>

            <div class="panel-body">
                <div class="mb-4">
                    <div class="row mt-4 mb-3 counts" v-if="isOk">
                        <div class="col-md-3">
                            Počet nových kurzov:
                            <b v-text="response.data.added_count"></b>
                        </div>
                        <div class="col-md-3">
                            Počet publikovaných kurzov:
                            <b v-text="response.data.updated_count"></b>
                        </div>
                        <div class="col-md-3">
                            Počet zmazaných kurzov:
                            <b v-text="response.data.deleted_count"></b>
                        </div>
                    </div>

                    <div class="row counts">
                        <div class="col-md-3">
                            Počet aktualizovaných kurzov:
                            <b v-text="response.data.updated_count"></b>
                        </div>
                        <div class="col-md-3">
                            Počet odpublikovaných kurzov:
                            <b v-text="response.data.unpublished_count"></b>
                        </div>
                        <div class="col-md-3">
                            Počet chybných kurzov:
                            <b v-text="response.data.error_count"></b>
                        </div>
                    </div>
                </div>

                <button v-if="response.data.error_count && ! debug" class="btn btn-warning mt-3" @click="showDebug">
                    Zobraziť chyby
                    &nbsp;
                    <span class="badge badge-warning" v-text="response.data.error_count"></span>
                </button>
            </div>

            <table class="table" v-if="debug && response.data.error_count">
                <thead>
                    <tr>
                        <th width="250">Kód kurzu</th>
                        <th width="300">Element</th>
                        <th>Chyby</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(errors, code) in response.data.errors">
                        <tr v-for="(messages, el) in errors">
                            <td>
                                <b v-text="code.replace(/code-/g, '')"></b>
                            </td>
                            <td>
                                <code v-text="el"></code>
                            </td>
                            <td>
                                <ul>
                                    <li v-for="message in messages" v-text="message"></li>
                                </ul>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </template>
        <template v-else>
            <div class="panel-heading" v-if="! response.success">
                Chyba!
            </div>

            <div class="panel-body" v-text="response.error.message"></div>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['finished', 'response'],

        data() {
            return {
                debug: false,
            }
        },

        methods: {
            showDebug() {
                this.debug = true;
            }
        },



        computed: {
            isOk() {
                return this.response.status === 202;
            },
        }
    }
</script>

<style scoped>
    .counts {
        font-size: 1.2em;
    }
    .counts .badge {
        font-size: 0.8em !important;
        height: 24px;
    }
    .subtitle {
        font-weight: bold;
        font-size: 1.2em;
    }

    .panel .table tr td:first-child,
    .panel .table tr th:first-child {
        padding-left: 1.5em;
    }

    .panel .table tr td:last-child,
    .panel .table tr th:last-child {
        padding-right: 1.5em;
    }
    .panel-heading {
        font-weight: bold;
    }
</style>
